import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["cancelText", "clearable", "clearText", "desktopModeMediaQuery", "DialogProps", "okText", "PopperProps", "showTodayButton", "todayText", "TransitionComponent"];
import * as React from 'react';
import { useThemeProps } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import DesktopDatePicker from '../DesktopDatePicker';
import MobileDatePicker from '../MobileDatePicker';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * Demos:
 *
 * - [Date Picker](https://mui.com/components/date-picker/)
 * - [Pickers](https://mui.com/components/pickers/)
 *
 * API:
 *
 * - [DatePicker API](https://mui.com/api/date-picker/)
 */

var DatePicker = /*#__PURE__*/React.forwardRef(function DatePicker(inProps, ref) {
  var props = useThemeProps({
    props: inProps,
    name: 'MuiDatePicker'
  });

  var cancelText = props.cancelText,
      clearable = props.clearable,
      clearText = props.clearText,
      _props$desktopModeMed = props.desktopModeMediaQuery,
      desktopModeMediaQuery = _props$desktopModeMed === void 0 ? '@media (pointer: fine)' : _props$desktopModeMed,
      DialogProps = props.DialogProps,
      okText = props.okText,
      PopperProps = props.PopperProps,
      showTodayButton = props.showTodayButton,
      todayText = props.todayText,
      TransitionComponent = props.TransitionComponent,
      other = _objectWithoutPropertiesLoose(props, _excluded);

  var isDesktop = useMediaQuery(desktopModeMediaQuery);
  return isDesktop ? /*#__PURE__*/_jsx(DesktopDatePicker, _extends({
    ref: ref,
    PopperProps: PopperProps,
    TransitionComponent: TransitionComponent
  }, other)) : /*#__PURE__*/_jsx(MobileDatePicker, _extends({
    ref: ref,
    cancelText: cancelText,
    clearable: clearable,
    clearText: clearText,
    DialogProps: DialogProps,
    okText: okText,
    showTodayButton: showTodayButton,
    todayText: todayText
  }, other));
});
process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default DatePicker;